import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CalendarClock, ArrowRight, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function DaPianificarePanel() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await api.get("/installazioni-da-pianificare/stats");
      setData(res.data);
    } catch {
      setData({ items: [], total: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  if (loading) return null;

  const items = data?.items || [];
  const total = data?.total || 0;

  return (
    <div className="card-shell p-5" data-testid="da-pianificare-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: "var(--accent)15", color: "var(--accent)" }}>
            <CalendarClock className="w-5 h-5" />
          </div>
          <div>
            <h2 className="font-bold text-lg" style={{ fontFamily: "Manrope" }}>Installazioni da Pianificare</h2>
            <p className="text-xs" style={{ color: "var(--text-muted)" }}>Clienti senza installazione completata né data, per commessa</p>
          </div>
        </div>
        <button
          onClick={() => navigate("/installazioni-da-pianificare")}
          className="text-xs font-semibold inline-flex items-center gap-1 hover:underline"
          style={{ color: "var(--primary)" }}
          data-testid="da-pianificare-vedi-tutti"
        >
          Vedi tutti <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>

      {total === 0 ? (
        <div className="text-sm py-4 text-center" style={{ color: "var(--text-muted)" }} data-testid="da-pianificare-empty">
          Nessun cliente da pianificare 🎉
        </div>
      ) : (
        <>
          <div className="mb-3">
            <span className="text-3xl font-extrabold" style={{ fontFamily: "Manrope", color: "var(--accent)" }} data-testid="da-pianificare-total">{total}</span>
            <span className="text-sm ml-2" style={{ color: "var(--text-muted)" }}>clienti totali</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {items.map((it) => (
              <button
                key={it.commessa_id || "_none"}
                onClick={() => navigate(`/installazioni-da-pianificare${it.commessa_id ? `?commessa=${it.commessa_id}` : ""}`)}
                className="flex items-center justify-between rounded-md px-3 py-2 text-left transition hover:bg-black/[0.02] border"
                style={{ borderColor: "var(--border)" }}
                data-testid={`da-pianificare-commessa-${it.commessa_id || "none"}`}
              >
                <span className="text-sm font-medium truncate mr-2">{it.commessa_name}</span>
                <span className="text-sm font-bold px-2 py-0.5 rounded-full shrink-0" style={{ background: "var(--accent)15", color: "var(--accent)" }}>{it.count}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
